import React from 'react';
import { TableListItem, Text } from '@wix/design-system';
import { ArrowRight } from '@wix/wix-ui-icons-common/odeditor';
import s from './BusinessNameRow.scss';
export const BusinessNameRow = _ref => {
  let {
    name,
    onSelect
  } = _ref;
  return /*#__PURE__*/React.createElement(TableListItem, {
    border: true,
    className: s.row,
    dataHook: "business-name-row",
    ariaLabel: name.name,
    horizontalPadding: "small",
    verticalPadding: "small",
    onClick: () => onSelect(name),
    options: [{
      value: /*#__PURE__*/React.createElement(Text, {
        size: "medium",
        weight: "bold",
        ellipsis: true
      }, name.name),
      width: 'minmax(0, 1fr)',
      align: 'left'
    }, {
      value: /*#__PURE__*/React.createElement(ArrowRight, {
        className: s.arrowIcon,
        "aria-hidden": true
      }),
      width: 24,
      align: 'right'
    }]
  });
};
//# sourceMappingURL=BusinessNameRow.js.map